import { OFFSET_DATA_AFTER_TREATMENT_END, OFFSET_DATA_BEFORE_TREATMENT_START, HIGH_RES_TIME_RATE, HIGHT_VOLUME_SAMPLING_RATE, SCROLLBAR_SAMPLING_RATE, REALTIME_REQUEST_RATE } from './../../../shared/services/scrollbar-chart-settings.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ScrollbarChartSettingsService, KEY_SCROLLBAR_SETTINGS, IScrollbarChartSettings, DEFAULT_REALTIME_BOURDET } from '../../../shared/services/scrollbar-chart-settings.service';
import { isBoolean } from 'lodash';

@Component({
  selector: 'app-misc-settings',
  templateUrl: './misc-settings.component.html',
  styleUrls: ['./misc-settings.component.scss']
})
export class MiscSettingsComponent implements OnInit {
  scrollbarSamplingRateOptions: string[] = ['1', '5', '10', '15', '20', '30']; // in min
  highVolumeSamplingRateOptions: string[] = ['10', '30', '60', '120', '600', '900', '1800']; // in sec
  highResTimeRateOptions: string[] = ['15', '30', '60', '120', '300']; // in min
  realtimeRequestRateOptions: string[] = ['1', '3', '5', '10', '30']; // in sec
  // offsetDataBeforeTreatmentStartOptions: string[] = ['0', '15', '30', '45', '60', '90', '120']; // in min
  // offsetDataAfterTreatmentEndOptions: string[] = ['0', '15', '30', '45', '60', '90', '120', '180', '240']; // in min
  multiWellScrollbar: boolean = true;
  realtimeBourdet: boolean = DEFAULT_REALTIME_BOURDET;

  form: FormGroup;
  curCompanyId: number;

  @Input()
  set companyId(id: number) {
    if (this.curCompanyId !== id) {
      this.curCompanyId = id;
      const localData = this.scrollbarChartSettingsService.getLocalStorage(this.curCompanyId, KEY_SCROLLBAR_SETTINGS);
      this.createForm(localData);
    }
  }

  constructor(
    private scrollbarChartSettingsService: ScrollbarChartSettingsService
  ) { }

  get scrollbarSamplingRate() {
    return this.form.controls.scrollbarSamplingRate;
  }

  get highVolumeSamplingRate() {
    return this.form.controls.highVolumeSamplingRate;
  }

  get highResTimeRate() {
    return this.form.controls.highResTimeRate;
  }

  get realtimeRequestRate() {
    return this.form.controls.realtimeRequestRate;
  }

  // get offsetDataBeforeTreatmentStart() {
  //   return this.form.controls.offsetDataBeforeTreatmentStart;
  // }

  // get offsetDataAfterTreatmentEnd() {
  //   return this.form.controls.offsetDataAfterTreatmentEnd;
  // }

  ngOnInit() {
    const localData = this.scrollbarChartSettingsService.getLocalStorage(this.curCompanyId, KEY_SCROLLBAR_SETTINGS);
    if (localData && isBoolean(localData.multiWellScrollbar)) {
      this.multiWellScrollbar = localData.multiWellScrollbar;
    }
    if (localData && isBoolean(localData.realtimeBourdet)) {
      this.realtimeBourdet = localData.realtimeBourdet;
    }
    this.createForm(localData);
  }

  createForm(data: Partial<IScrollbarChartSettings>) {
    data = data || {};
    this.form = new FormGroup({
      scrollbarSamplingRate: new FormControl(data.scrollbarSamplingRate || SCROLLBAR_SAMPLING_RATE),
      highVolumeSamplingRate: new FormControl(data.highVolumeSamplingRate || HIGHT_VOLUME_SAMPLING_RATE),
      highResTimeRate: new FormControl(data.highResTimeRate || HIGH_RES_TIME_RATE),
      realtimeRequestRate: new FormControl(data.realtimeRequestRate || REALTIME_REQUEST_RATE),
      // offsetDataBeforeTreatmentStart: new FormControl(data.offsetDataBeforeTreatmentStart || OFFSET_DATA_BEFORE_TREATMENT_START),
      // offsetDataAfterTreatmentEnd: new FormControl(data.offsetDataAfterTreatmentEnd || OFFSET_DATA_AFTER_TREATMENT_END),
      multiWellScrollbar: new FormControl(this.multiWellScrollbar),
      realtimeBourdet: new FormControl(this.realtimeBourdet)
    });
  }

  onChangeSamplingRateOption(eventData) {
    if (eventData && eventData.id) {
      this.scrollbarSamplingRate.setValue(eventData.id);
      const dataState = this.getState();
      this.setState(dataState);
    }
  }

  onChangeHighVolumeRateOption(eventData) {
    if (eventData && eventData.id) {
      this.highVolumeSamplingRate.setValue(eventData.id);
      const dataState = this.getState();
      this.setState(dataState);
    }
  }

  onChangeHighResTimeRateOption(eventData) {
    if (eventData && eventData.id) {
      this.highResTimeRate.setValue(eventData.id);
      const dataState = this.getState();
      this.setState(dataState);
    }
  }

  onChangeMultiWellScrollbar(eventData) {
    if (eventData == null || eventData === undefined) return;
    const dataState = this.getState();
    dataState.multiWellScrollbar = eventData;
    this.multiWellScrollbar = eventData;
    this.setState(dataState);
  }

  onChangeRealtimeRequestRateOption(eventData) {
    if (eventData == null || eventData === undefined) return;
    this.realtimeRequestRate.setValue(eventData.id);
    const dataState = this.getState();
    this.setState(dataState);
  }

  onChangeRealtimeBourdet(eventData) {
    if (eventData == null || eventData === undefined) return;
    const dataState = this.getState();
    dataState.realtimeBourdet = eventData;
    this.realtimeBourdet = eventData;
    this.setState(dataState);
  }

  private setState(dataState) {
    this.scrollbarChartSettingsService.setDataState(dataState);
    this.scrollbarChartSettingsService.setLocalStorage(this.curCompanyId, KEY_SCROLLBAR_SETTINGS, dataState);
  }

  private getState() {
    if (!this.form) return null;
    // note that: formGroup doesn't support ui-switch with custom ngModel
    const dataState = this.form.getRawValue();
    dataState.multiWellScrollbar = this.multiWellScrollbar;
    dataState.realtimeBourdet = this.realtimeBourdet;
    return dataState;
  }
}
